import React from 'react';

const ChevronRight: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'inline-block', verticalAlign: 'middle', opacity: 1, transform: 'rotate(0deg)', ...style }}
    className={className}
  >
    <path d="M9 6l6 6-6 6" stroke="#9CA3AF" strokeWidth={1.08} strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ChevronRight;
